(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/company-details/components/company-details-form/company-details-form.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/company-details/components/company-details-form/company-details-form.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  useContext,
  useEffect,
  Fragment,
  useState
} = React;
const {
  RECEIVE_COMPANY_DETAILS,
  EDIT_MODE
} = svs.ticket_partner.companyDetails.constants.actions;
const {
  HEADER,
  EDIT_LABEL,
  CANCEL_LABEL,
  SAVE_LABEL,
  SAVE_SUCCESS
} = svs.ticket_partner.companyDetails.constants.TEXTS;
const {
  GridCol
} = svs.ui.ReactGrid;
const {
  Form
} = svs.ui.reactForm;
const {
  ContactPerson,
  Addresses
} = svs.ticket_partner.companyDetails.components.companyDetailsForm.components;
const {
  ButtonRow
} = svs.ticket_partner.sharedComponents.buttonRow;
const {
  mapUpdateCompanyCustomerError
} = svs.ticket_partner.services;
const {
  createUpdateCompanyCustomerRequest
} = svs.ticket_partner.companyDetails.utils;
const CompanyDetails = _ref => {
  let {
    handleSubmit
  } = _ref;
  const {
    dispatch,
    state
  } = useContext(svs.ticket_partner.CompanyDetailsContext);
  const {
    edit
  } = state.companyDetails;
  const [beforeEditState, setBeforeEditState] = useState(null);
  const saveAndCancelBtns = [{
    className: 'margin-right-1',
    label: CANCEL_LABEL,
    key: 'cancel-btn',
    transparent: true,
    onClick: e => {
      e.preventDefault();
      dispatch({
        type: EDIT_MODE,
        payload: {
          edit: false,
          beforeEditState
        }
      });
    }
  }, {
    label: SAVE_LABEL,
    key: 'save-btn',
    focus: true,
    type: 'submit'
  }];
  const editBtn = [{
    label: EDIT_LABEL,
    key: 'edit-btn',
    focus: true,
    onClick: e => {
      e.preventDefault();
      setBeforeEditState(state.companyDetails);
      dispatch({
        type: EDIT_MODE,
        payload: {
          edit: true
        }
      });
    }
  }];
  return edit ? React.createElement(Form, {
    onSubmit: handleSubmit
  }, React.createElement(ContactPerson, null), React.createElement(Addresses, null), React.createElement(ButtonRow, {
    buttons: saveAndCancelBtns,
    className: "margin-top-2"
  })) : React.createElement(Fragment, null, React.createElement(ContactPerson, null), React.createElement(Addresses, null), React.createElement(ButtonRow, {
    buttons: editBtn,
    className: "margin-top-2"
  }));
};
const CompanyDetailsForm = () => {
  const {
    companyDetailsPromise
  } = svs.ticket_partner.useUserContext();
  const [fetchingDetails, setFetchingDetails] = useState(true);
  const {
    dispatch,
    state
  } = useContext(svs.ticket_partner.CompanyDetailsContext);

  useEffect(async () => {
    svs.ui.loader.show();
    const {
      companyDetails
    } = await companyDetailsPromise;
    if (companyDetails) {
      dispatch({
        type: RECEIVE_COMPANY_DETAILS,
        payload: _objectSpread({}, companyDetails)
      });
    }
    svs.ui.loader.hide();
    setFetchingDetails(false);
  }, [companyDetailsPromise]);
  const handleSubmit = async (e, formData) => {
    e === null || e === void 0 || e.preventDefault();
    if (_.values(formData).some(_ref2 => {
      let {
        isValid
      } = _ref2;
      return !isValid;
    })) {
      return;
    }
    svs.ui.loader.show();
    const requestData = createUpdateCompanyCustomerRequest(state);
    try {
      await svs.ticket_partner.services.updateCompanyCustomer(requestData);
      dispatch({
        type: EDIT_MODE,
        payload: {
          edit: false
        }
      });
      svs.ticket_partner.utils.showSuccessDialog('', SAVE_SUCCESS);
    } catch (e) {
      const errorMessage = mapUpdateCompanyCustomerError(e);
      svs.ticket_partner.utils.showErrorDialog(errorMessage);
    }
    svs.ui.loader.hide();
  };
  return React.createElement(GridCol, {
    className: "u-text-left",
    md: 6,
    sm: 12
  }, React.createElement("h1", null, HEADER), !fetchingDetails ? React.createElement(CompanyDetails, {
    handleSubmit: handleSubmit
  }) : null);
};
svs.ticket_partner.companyDetails.components.CompanyDetailsForm = CompanyDetailsForm;

 })(window);